//esse essa importação { React } esta errada.
import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Grid, Container } from "@mui/material";
import api from "../../services/api";
import UpdateComplait from "./updateComplaint";
import DetailsComplait from "./detailsComplaint";
import MidiaComplaint from "./imageComplaint";
import ComentComplaint from "./comentComplaint";
import UserPermission from "../../components/UserPermission";
import MultiManual from "../../components/Manual/MultiManual";
import ShowFeedback from "./ShowFeedback";
import "./styles.css";
import Breadcrumb from "../../components/Breadcrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import StepperStatus from "../../components/StepperStatus";
import ArrowLeft from '../../assets/seta-left.svg';
import ArrowRight from '../../assets/seta-right.svg';
import { toast } from "react-toastify";

export default function Details() {
  const from = useLocation().state?.from || [
    { href: "/search", name: "Ocorrências" },
  ];

  /* Permissão do usuário no sistema */
  let userPermission = UserPermission();

  /* Variáveis constantes que recebem valor do localstorage ou url */
  const idUser = localStorage.getItem("IdUser");

  // Criação do navigate para mudar o URL;
  let navigate = useNavigate();
  const location = useLocation();

  const [idComplaint, setIdComplaint] = useState(
    window.location.pathname.split("/").pop()
  );
  const [indexComplaint, setIndexComplaint] = useState(-1);

  // Aqui é o array de ocorrencias que é puxado do sessionStorage.
  const arrayiDComplaints = useMemo(() => {
    return JSON.parse(sessionStorage.getItem("idComplaintsFiltered") || "[]");
  }, []);

  // Executa sempre que "idComplaint" for alterado
  useEffect(() => {
    if (arrayiDComplaints && arrayiDComplaints.length > 0) {
      const foundIndex = arrayiDComplaints.findIndex(
        (item) => item === idComplaint
      );
      if (foundIndex !== -1) setIndexComplaint(foundIndex);
    }
  }, [idComplaint, arrayiDComplaints]);

  useEffect(() => {
    const newId = location.pathname.split("/").pop();
    setIdComplaint(newId);
  }, [location]);

  // Função responsável pela navegação ao pressionar os botões "Próxima Ocorrencia" ou "Ocorrencia Anterior"
  const debounceTimerRef = useRef(null);
  function navigateCarousel(direction) {
    clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = setTimeout(() => {
      // Apenas navega; idComplaint e indexComplaint são atualizados pelos effects.
      const newIndex = indexComplaint + direction;
      if (newIndex >= 0 && newIndex < arrayiDComplaints.length) {
        const newId = arrayiDComplaints[newIndex];
        navigate(`/details/${newId}`, { state: { from } });
      }
    }, 500);
  }

  // Criamos referencias aos botões
  const buttonNext = useRef();
  const buttonPrevious = useRef();

  // Verificamos se o botão existe e se a array é maior que 0.
  if (buttonNext.current && arrayiDComplaints.length <= 0)
    buttonNext.current.disabled = true;
  if (buttonPrevious.current && arrayiDComplaints.length <= 0)
    buttonPrevious.current.disabled = true;

  // Efeito que executa sempre que "indexComplaint" ou "arrayiDComplaints" for alterado
  useEffect(() => {
    if (!arrayiDComplaints || arrayiDComplaints.length === 0) return;

    buttonNext.current.disabled =
      indexComplaint + 1 === arrayiDComplaints.length;
    buttonPrevious.current.disabled = indexComplaint === 0;
  }, [indexComplaint, arrayiDComplaints]);

  /* Estados que armazenam array de resultados */
  const [executorInfo, setExecutorInfo] = useState([]);
  const [controladorInfo, setControladorInfo] = useState([]);
  const [nameExecutor, setNameExecutor] = useState([]);
  const [complaints, setComplaints] = useState([]);
  const [comment, setComment] = useState([]);
  const [areas, setAreas] = useState([]);

  /* Estados que armazenam valores de string */
  const [description, setDescription] = useState("");
  const [originalArea, setOriginalArea] = useState("");
  const [idExecutor, setIdExecutor] = useState("");
  const [feedback, setFeedback] = useState("");
  const [midias, setMidias] = useState([]);
  const [isLoadingMidias, setIsLoadingMidias] = useState(true);
  const [isLoadingMining, setIsLoadingMining] = useState(false);

  /* Add new state for classification results */
  const [classification, setClassification] = useState(null);

  /* GET informações das ocorrências */
  useEffect(() => {
    api.get(`${userPermission}/complaints/${idComplaint}`).then((response) => {
      setComplaints([response.data]);
      setDescription([response.data.description]);
      setOriginalArea(response.data.originalArea);
      setIdExecutor(response.data.executorId);
    });
  }, [userPermission, idComplaint]);

  /* Classificação automática de área (sugestão via IA - Conecta Mining) - DESATIVADA */
  // useEffect(() => {
  //   let isCancelled = false;
  //
  //   const classifyByImage = async () => {
  //     const response = await api.post("/admin/complaints/classify-image", {
  //       complaint_id: idComplaint,
  //       picture_id: complaints[0].pictures[0].id,
  //     });
  //     return response.data.category;
  //   };
  //
  //   const classifyContent = async () => {
  //     const hasPictures = complaints[0]?.pictures?.length > 0;
  //
  //     setIsLoadingMining(true);
  //     setClassification(null);
  //
  //     try {
  //       let category;
  //
  //       if (description && description.length > 0) {
  //         try {
  //           const response = await api.post("/admin/complaints/classify", {
  //             text: description[0],
  //           });
  //           category = response.data.category;
  //
  //           if (category === "Outros" && hasPictures) {
  //             category = await classifyByImage();
  //           }
  //         } catch (err) {
  //           //Se a classificação por texto falhar, tenta por imagem antes de desistir
  //           if (!hasPictures) throw err;
  //           category = await classifyByImage();
  //         }
  //       } else if (hasPictures) {
  //         category = await classifyByImage();
  //       }
  //
  //       if (!isCancelled) setClassification(category ?? null);
  //     } catch (err) {
  //       if (!isCancelled) {
  //         toast.error(
  //           "Não foi possível obter uma sugestão de área para esta ocorrência."
  //         );
  //       }
  //     } finally {
  //       if (!isCancelled) setIsLoadingMining(false);
  //     }
  //   };
  //
  //   if (
  //     (!originalArea || originalArea === "") &&
  //     ((description && description.length > 0) ||
  //       complaints[0]?.pictures?.length > 0)
  //   ) {
  //     classifyContent();
  //   }
  //
  //   return () => {
  //     isCancelled = true;
  //   };
  // }, [description, complaints, idComplaint, originalArea]);

  /* GET todas as áreas cadastradas */
  useEffect(() => {
    api.get(`${userPermission}/areas`).then((response) => {
      setAreas(response.data);
    });
  }, [userPermission]);

  /* Coleta somente informações que os manager e admin podem visualizar */
  useEffect(() => {
    if (userPermission === "manager" || userPermission === "admin") {
      /* GET informações de todos os executores */
      api
        .get(`${userPermission}/users?filter={"where":{"role":"Executor"}}`)
        .then((response) => {
          setExecutorInfo(response.data);
        });

      /* GET informações de todos os controladores */
      api
        .get(`${userPermission}/users?filter={"where":{"role":"Controlador"}}`)
        .then((response) => {
          setControladorInfo(response.data);
        });

      /* Coleta informações do executor responsável por uma ocorrência, caso haja um executor associado */
      if (idExecutor !== "" || idExecutor !== undefined) {
        api
          .get(
            `${userPermission}/users?filter={"where":{"id":"${idExecutor}"}}`
          )
          .then((response) => {
            setNameExecutor(response.data.map((value) => value.name));
          });
      }
    }

    api
      .get(
        `/admin/evaluations?filter={"where":{"complaintId":"${idComplaint}"}}`
      )
      .then((response) => {
        setFeedback(response.data.map((value) => value.description));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [userPermission, idUser, idComplaint, idExecutor]);

  /* Função para buscar comentários - usada no useEffect e após envio de novo comentário */
  const fetchComments = useCallback(async () => {
    try {
      let response;
      if (userPermission === "manager" || userPermission === "executor") {
        response = await api.get(`${userPermission}/complaints/${idComplaint}/coments`);
      } else {
        response = await api.get(
          `${userPermission}/coments?filter={"where":{"complaintId":"${idComplaint}"}}`
        );
      }
      setComment(response.data);
    } catch (err) {
      console.error('Erro ao buscar comentários:', err);
    }
  }, [userPermission, idComplaint]);

  /* Se o usuário for controlador ou executor, coleta as informações de comentários das ocorrências */
  useEffect(() => {
    fetchComments();
  }, [fetchComments]);

  // Evita refetch duplicado das mídias para o mesmo conjunto de fotos.
  const midiasSignatureRef = useRef(null);

  /* Ao navegar, limpa a mídia anterior e volta ao loading imediatamente para
     não deixar a imagem da ocorrência anterior visível (piscada). */
  useEffect(() => {
    setMidias([]);
    setIsLoadingMidias(true);
  }, [idComplaint]);

  /* Coleta informações da imagem da ocorrência (URL) */
  useEffect(() => {
    // Deriva o id de `complaints[0]` (e não do estado `idComplaint`) para o
    // fetch só rodar quando os dados realmente chegam — uma vez por ocorrência.
    const complaint = complaints[0];
    const pictures = complaint?.pictures;
    if (complaint?.id && pictures?.length !== undefined) {
      const signature = `${complaint.id}:${pictures.map((p) => p.id).join(",")}`;
      if (midiasSignatureRef.current === signature) return;
      midiasSignatureRef.current = signature;

      setIsLoadingMidias(true);
      const images = pictures.map((pic) => {
        return api.get(
          `${userPermission}/complaints/${complaint.id}/pictures/${pic.id}`
        );
      });

      Promise.all(images)
        .then((res) => {
          // Define as mídias antes de desligar o loading para evitar um render
          // com isLoading=false e midias=[] (flash de "Mídia indisponível").
          setMidias(res.map((r) => r.data));
          setIsLoadingMidias(false);
        })
        .catch((err) => {
          setIsLoadingMidias(false);
          toast.error("Houve um erro ao carregar as imagens");
        });
    }
  }, [complaints, userPermission]);

  return (
    <div className="details-container">
      <Breadcrumb paths={[...from, { href: "/", name: "Detalhes" }]} />
      <br />
      <div style={{ width: "100%" }}>
        <Container maxWidth={false}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} lg={12} xl={12}>
              <div>
                <button
                  ref={buttonPrevious}
                  onClick={() => navigateCarousel(-1)}
                  className="icon-button left"
                  aria-label="Ocorrência anterior"
                >
                  <img src={ArrowLeft} alt="Anterior" className="arrow-icon" />
                </button>

                <button
                  ref={buttonNext}
                  onClick={() => navigateCarousel(1)}
                  className="icon-button right"
                  aria-label="Próxima ocorrência"
                >
                  <img src={ArrowRight} alt="Próxima" className="arrow-icon" />
                </button>
              </div>

              <StepperStatus
                createdAt={complaints[0]?.createdAt}
                complaintId={complaints[0]?.id}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              lg={7}
              xl={7}
              style={{ minHeight: "542px" }}
            >
              <DetailsComplait
                complaint={complaints}
                nameExecutor={nameExecutor}
                classification={classification}
                originalArea={originalArea}
                isLoading={isLoadingMining}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              lg={5}
              xl={5}
              style={{ minHeight: "542px" }}
            >
              <MidiaComplaint
                isLoading={isLoadingMidias}
                description={description}
                midias={midias}
                idComplaint={idComplaint}
                executorComment={complaints[0]?.executorComment}
              />
            </Grid>

            <Grid
              item
              id="coment-complaint-details"
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >
              <ComentComplaint
                id_complaint={idComplaint}
                userPermission={userPermission}
                comment={comment}
                cod_complaint={
                  complaints.length > 0 ? complaints[0].reference : ""
                }
                onCommentAdded={fetchComments}
                controladorName={complaints[0]?.controladorName}
              />
            </Grid>

            <Grid
              item
              id="coment-complaint-details"
              lg={20}
              sm={12}
              xl={12}
              xs={12}
            >
              <ShowFeedback feedback={feedback} />
            </Grid>

            <Grid
              item
              id="edit-complaints-details"
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >
              <div className="edit-complaints">
                <UpdateComplait
                  areas={areas}
                  executor={executorInfo}
                  controlador={controladorInfo}
                  complaints={complaints}
                  idComplaint={idComplaint}
                  userPermission={userPermission}
                  status={complaints[0]?.status}
                />
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <MultiManual
        components={[
          {
            id: "coment-complaint-details",
            message:
              "Nesta área estará os comentários dos responsáveis envolvidos com a ocorrência",
          },
          {
            id: "edit-complaints-details",
            message:
              "Você pode editar eventualmente os dados da ocorrência de acordo com a necessidade de mantê-la atualizada",
          },
        ]}
      />
    </div>
  );
}
